import { render, staticRenderFns } from "./PitchIndex.vue?vue&type=template&id=b55f2590"
import script from "./PitchIndex.vue?vue&type=script&lang=js"
export * from "./PitchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports